import React, { useEffect } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import TopPageButton from "../Components/TopPage/TopePage";
import { Helmet } from "react-helmet-async";

const OnlineResume = () => {
  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Online Resume | Aneeq Ullah Khan</title>
        <meta
          name="description"
          content="You can also check and download my resume from here if you are a client or a recruiter this page is best for you."
        />
        <meta
          name="keywords"
          content="Aneeq Ullah Khan, Aneeq Ullah Khan Resume Online, Resume Online Aneeq Ullah Khan, Aneeq Khan REsume Online"
        />
      </Helmet>

      <Navbar />
      <div className="container mt-5 mb-5">
        <h3 class="text-center text-aneeq fw-bolder">
          Aneeq Ullah Khan Resume
        </h3>
        <br />
        <div className="mt-5 mb-5">
          <h5>Aneeq Ullah Khan</h5>
          <h6>
            React Developer | MERN Stack Developer | Firebase Developer | PHP
            Developer | Wordpress Developer
          </h6>
          <h6>North Nazimabad, Karachi, Pakistan</h6>
          <h6>aneequllah.khan@outlook.com</h6>
          <h6>+92 306 2341354</h6>
          <br />
          <h5>Objective</h5>
          <hr />
          <p>
            Secure a responsible and future career so need job to get some
            experiences and knowledge and making a significant contribution to
            the success of the company. Seeking an entry-level position to begin
            my career in a high-level professional environment. I'm a
            high-energy student volunteer currently finalizing Bachelor in
            Computer Science and prepared to contribute to organizational
            success while developing new skills and gaining real-world
            experience. Highly organized and responsible with strong
            communication and critical thinking skills.
          </p>
          <br />
          <h5>Experienced</h5>
          <hr />
          <h6>Freelancer at Fiverr</h6>
          <h6>Niche: Web Application Development</h6>
          <p>From November 2022 till Present</p>

          <br />
          <h5>Education</h5>
          <hr />
          <h6>Bachelor's In Computer Sciences (2 Semester)</h6>
          <h6>Iqra University - Main Campus Karachi</h6>
          <p>From October 2022 till Present</p>
          <br />
          <h6>Diploma In Information Systems Management (DISM)</h6>
          <h6>Aptech North Nazimabad - Karachi</h6>
          <p>From Dec 2021 to Jan 2023</p>
          <br />
          <h6>Intermediate in Pre-Engineering</h6>
          <h6>DJ Govt Science College - Karachi</h6>
          <p>From October 2020 to July 2022</p>
          <br />
          <h6>Matriculation in Computer Science</h6>
          <h6>The Times School - Main Campus Karachi</h6>
          <p>From March 2018 to April 2020</p>

          <br />
          <h5>Certifications</h5>
          <hr />

          <h6>MERN App Development</h6>
          <h6>Jawan Pakistan</h6>

          <br />
          <h6>Simplilearn</h6>
          <h6>React JS For Beginners</h6>

          <br />
          <h6>Google Digital Garage</h6>
          <h6>The Fundamentals Of Digital Marketing</h6>

          <br />
          <h6>Open Weaver</h6>
          <h6>Html And Css For Beginners</h6>

          <br />
          <h5>Honors And Awards</h5>
          <hr />
          <h6>Certificate Of Appreciation In TECHBLADE 1.0</h6>
          <h6>
            Issued by Google Developer Student Club Iqra University Karachi ·
            Nov 2022
          </h6>
          <br />
          <h6>Certification Of Participation In TECHWIZ 3</h6>
          <h6>Issued by Aptech · Sep 2022</h6>
          <br />
          <h6>Certification Of Membership Of PAFLA</h6>
          <h6>
            Issued by PAFLA - Pakistan Freelancers Association Issued Aug 2023
          </h6>

          <br />
          <h5>Skills</h5>
          <hr />
          <li>React JS</li>
          <li>HTML 5</li>
          <li>CSS 3</li>
          <li>Javascript</li>
          <li>Bootstrap</li>
          <li>Material UI</li>
          <li>Firebase</li>
          <li>Git Bash / Github</li>
          <li>React Native</li>
          <li>Node JS</li>
          <li>Express JS</li>
          <li>Mongo DB</li>
          <li>PHP</li>
          <li>Wordpress</li>
          <li>WooCommerce</li>
          <li>MS Office</li>
          <li>C++</li>
          <li>IOT Programming</li>
          <br />
          <h5>Personality Highlights</h5>
          <hr />
          <li>Team Lead</li>
          <li>Ability To Work In Team</li>
          <li>Time Management</li>
          <li>Collaborative And Efficient</li>
          <li>Problem Solving</li>
          <li>Fast Learner</li>

          <br />
          <h5>Additional Information</h5>
          <hr />
          <p>Marital Status : Single</p>
          <p>Gender : Male</p>
          <p>Nationality : Pakistani</p>
          <p>English - Intermediate</p>
          <p>Urdu - Fluent</p>
          <br />
        </div>
      </div>
      <Footer />
      <TopPageButton />
    </React.Fragment>
  );
};

export default OnlineResume;
